export function getCognitoConfig() {
    return {
        region: window.COGNITO_REGION,
        userPoolId: window.COGNITO_USER_POOL_ID,
        clientId: window.COGNITO_CLIENT_ID,
        domain: window.COGNITO_DOMAIN,
    };
}
export function getHostedUiUrl(redirectUri) {
    const { region, domain, clientId } = getCognitoConfig();
    const params = new URLSearchParams({
        client_id: clientId,
        response_type: 'token',
        scope: 'openid email profile',
        redirect_uri: redirectUri,
    });
    return `https://${domain}.auth.${region}.amazoncognito.com/login?${params}`;
}
